function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2002 4.2002H19.8002L19.8002 19.8002L4.2002 19.8002V4.2002ZM3.2002 4.2002C3.2002 3.64791 3.64791 3.2002 4.2002 3.2002H19.8002C20.3525 3.2002 20.8002 3.64791 20.8002 4.2002V19.8002C20.8002 20.3525 20.3525 20.8002 19.8002 20.8002H4.2002C3.64791 20.8002 3.2002 20.3525 3.2002 19.8002V4.2002ZM16.3124 8.64811C16.4687 8.42043 16.4108 8.10919 16.1831 7.95293C15.9554 7.79668 15.6442 7.85458 15.4879 8.08226L10.6476 15.1351L8.08502 12.046C7.90871 11.8334 7.5935 11.8041 7.38096 11.9804C7.16843 12.1567 7.13906 12.4719 7.31537 12.6844L10.3005 16.2829C10.4006 16.4036 10.5515 16.4703 10.7081 16.4632C10.8647 16.4561 11.0089 16.3759 11.0976 16.2466L16.3124 8.64811Z",
  fill: "#4F4F4F"
});
function SvgCheckboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkboxActive.a34acfc291e07a0ef58f6e699fcfd46a.svg";
export { ForwardRef as ReactComponent };